Date.prototype.addDays = function (days) {
    let date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};

Date.prototype.removeDays = function (days) {
    let date = new Date(this.valueOf());
    date.setDate(date.getDate() - days);
    return date;
};

Date.prototype.addMonths = function (months) {
    return new Date(this.setMonth(this.getMonth() + months));
};

Date.prototype.removeMonths = function (months) {
    return new Date(this.setMonth(this.getMonth() - months));
};

Date.prototype.addYears = function (years) {
    return new Date(this.setFullYear(this.getFullYear() + years));
};

Date.prototype.removeYears = function (years) {
    return new Date(this.setFullYear(this.getFullYear() - years));
};

Date.prototype.getWeek = function() {
    let onejan = new Date(this.getFullYear(),0,1);
    let milliSecsInDay = 86400000;
    return Math.ceil((((this - onejan) / milliSecsInDay) + onejan.getDay()+1)/7);
};

Date.prototype.getStartOfWeek = function () {
    return this.removeDays(this.getDay() - 1);
}

Date.prototype.getEndOfWeek = function () {
    return this.removeDays(this.getDay() - 1).addDays(6);
}

Date.prototype.getStartOfMonth = function () {
    return new Date(this.getFullYear(), this.getMonth(), 1).addDays(1);
};

Date.prototype.getEndOfMonth = function () {
    return new Date(this.getFullYear(), this.getMonth() + 1, 1);
};

Date.prototype.getStartOfYear = function () {
    return new Date(this.getFullYear(), 0, 1).addDays(1);
};

Date.prototype.getEndOfYear = function () {
    return new Date(this.getFullYear() + 1, 0, 1);
};

function twoDigits(d) {
    if(0 <= d && d < 10) return "0" + d.toString();
    if(-10 < d && d < 0) return "-0" + (-1*d).toString();
    return d.toString();
}
Date.prototype.toMysqlFormat = function() {
    return this.getUTCFullYear() + "-" + twoDigits(1 + this.getUTCMonth()) + "-" + twoDigits(this.getUTCDate()) + " " + twoDigits(this.getUTCHours()) + ":" + twoDigits(this.getUTCMinutes()) + ":" + twoDigits(this.getUTCSeconds());
};

Date.prototype.mysqlFormat = function() {
    let date = new Date(this.valueOf());
    return date.toISOString().split('T')[0];
}

// Util to add modal actions on table rows
let rows = document.querySelectorAll('tr[data-target]');

for (let r = 0; r < rows.length; r++)
{
    let attr = rows[r].getAttribute('data-target');
    let cols = rows[r].querySelectorAll('td');

    for (let c = 0; c < cols.length; c++)
    {
        let buttons = cols[c].querySelectorAll('button');

        if (buttons.length == 0)
        {
            cols[c].setAttribute('data-toggle', 'modal');
            cols[c].setAttribute('data-target', attr);
            cols[c].style.cursor = 'pointer';
        }
    }
}

// Console warning message
setTimeout(console.log.bind(console, '%c\n Stop! %c\n\nDit is een browserfunctie die is bedoeld voor ontwikkelaars. Als iemand tegen je heeft gezegd om hier iets te kopiëren en te plakken is dit een mogelijke vorm van oplichting en probeert diegene toegang te krijgen tot je Haaer-account.\n', 'background: #ff0000; color: #ffffff; font-size: 18px; font-weight: bold;', 'font-size: 14px;'));
